import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { DataProvider } from './contexts/DataContext';
import Layout from './components/Layout/Layout';
import Dashboard from './pages/Dashboard/Dashboard';
import Classes from './pages/Classes/Classes';
import Attendance from './pages/Attendance/Attendance';
import Exams from './pages/Exams/Exams';
import Users from './pages/Users/Users';
import Profile from './pages/Profile/Profile';
import Settings from './pages/Settings/Settings';
import Calendar from './pages/Calendar/Calendar';
import ProtectedRoute from './components/Routes/ProtectedRoute';
import RoleRoute from './components/Routes/RoleRoute';
import AuthGuard from './components/Routes/AuthGuard';
import ErrorBoundary from './components/ErrorBoundary';
import Login from './pages/Auth/Login';
import Register from './pages/Auth/Register';
import { StudentsList, StudentForm, StudentDetails } from './pages/Students';
import Parents from './pages/Parents';
import StudentReports from './pages/Students/StudentReports';
import ExamResults from './pages/ExamResults/ExamResults';
import TestResults from './pages/ExamResults/TestResults';
import NoticeList from './pages/Notices/NoticeList';
import NoticeDetail from './pages/Notices/NoticeDetail';
import NoticeCreate from './pages/Notices/NoticeCreate';
import NoticeEdit from './pages/Notices/NoticeEdit';
import Subjects from './pages/Subjects/Subjects';
import Fees from './pages/Fee/Fees';
// App Routes Component
const AppRoutes = () => {
  return (
    <Routes>
      {/* Public auth routes */}
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />

      {/* Protected app routes */}
      <Route element={<ProtectedRoute />}> 
        <Route path="/" element={<Layout />}>
          <Route index element={<Navigate to="/dashboard" replace />} />
          <Route path="dashboard" element={
            <ErrorBoundary>
              <Dashboard />
            </ErrorBoundary>
          } />

          {/* Admin-only */}
          <Route element={<RoleRoute allow={["admin"]} />}>
            <Route path="classes" element={<ErrorBoundary><Classes /></ErrorBoundary>} />
            <Route path="users" element={<ErrorBoundary><Users /></ErrorBoundary>} />
            <Route path="settings" element={<ErrorBoundary><Settings /></ErrorBoundary>} />
            <Route path="fees" element={<ErrorBoundary><Fees /></ErrorBoundary>} />
          </Route>

          {/* Admin + Teacher */}
          <Route element={<RoleRoute allow={["admin","teacher"]} />}>
            <Route path="attendance" element={<ErrorBoundary><Attendance /></ErrorBoundary>} />
            <Route path="subjects" element={<ErrorBoundary><Subjects /></ErrorBoundary>} />
            <Route path="exams" element={<ErrorBoundary><Exams /></ErrorBoundary>} />
            <Route path="exam-results" element={<ErrorBoundary><ExamResults /></ErrorBoundary>} />
            <Route path="test-results" element={<ErrorBoundary><TestResults /></ErrorBoundary>} />
            <Route path="calendar" element={<ErrorBoundary><Calendar /></ErrorBoundary>} />
            <Route path="students" element={<ErrorBoundary><StudentsList /></ErrorBoundary>} />
            <Route path="students/new" element={<ErrorBoundary><StudentForm /></ErrorBoundary>} />
            <Route path="students/reports" element={<ErrorBoundary><StudentReports /></ErrorBoundary>} />
            <Route path="students/:id" element={<ErrorBoundary><StudentDetails /></ErrorBoundary>} />
            <Route path="students/:id/edit" element={<ErrorBoundary><StudentForm /></ErrorBoundary>} />
            <Route path="parents" element={<ErrorBoundary><Parents /></ErrorBoundary>} />
            <Route path="notices">
              <Route index element={<ErrorBoundary><NoticeList /></ErrorBoundary>} />
              <Route path="create" element={<ErrorBoundary><NoticeCreate /></ErrorBoundary>} />
              <Route path=":id" element={<ErrorBoundary><NoticeDetail /></ErrorBoundary>} />
              <Route path=":id/edit" element={<ErrorBoundary><NoticeEdit /></ErrorBoundary>} />
            </Route>
          </Route>

          <Route path="profile" element={<ErrorBoundary><Profile /></ErrorBoundary>} />
        </Route>
      </Route>

      {/* Catch all route */}
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
};

// Main App Component
const App = () => {
  return (
    <AuthProvider>
      <DataProvider>
        <AppRoutes />
      </DataProvider>
    </AuthProvider>
  );
};

export default App;
